var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgSirenTurnedOn = function SvgSirenTurnedOn(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "svg3585",
    width: 44,
    height: 44,
    ref: ref
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(0 -1008.4)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g4029",
    stroke: "currentColor",
    strokeLinejoin: "round",
    transform: "translate(-260.22 990.36)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "rect3994",
    fill: "currentColor",
    strokeWidth: 1.8,
    d: "M269.5 35.5h5.5l7.5-7v23l-7.5-7h-5.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3997",
    fill: "none",
    strokeLinecap: "round",
    strokeWidth: 2.7,
    d: "M291 31s3.5 2.68 3.5 9-3.5 9-3.5 9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3999",
    fill: "none",
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "M287.7 33.7s2.545 2.036 2.545 6.401S287.7 46.3 287.7 46.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4001",
    fill: "none",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M284.5 36.5s1.989 1.235 1.989 3.557S284.5 43.5 284.5 43.5"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgSirenTurnedOn);
export default ForwardRef;